<script setup>
const props = defineProps({
	color: String,
})
</script>

<template >
	<svg width="30" height="21" viewBox="0 0 30 21" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M2.25 3.17004H27.53C28.36 3.17004 29.03 2.50004 29.03 1.67004C29.03 0.840044 28.36 0.170044 27.53 0.170044H2.25C1.42 0.170044 0.75 0.840044 0.75 1.67004C0.75 2.50004 1.42 3.17004 2.25 3.17004Z"
			:fill="`rgb(var(--color-${color}) / 1)`"
		/>
		<path d="M27.53 8.62H2.25C1.42 8.62 0.75 9.29 0.75 10.12C0.75 10.95 1.42 11.62 2.25 11.62H27.53C28.36 11.62 29.03 10.95 29.03 10.12C29.03 9.29 28.36 8.62 27.53 8.62Z"
			:fill="`rgb(var(--color-${color}) / 1)`"
		/>
		<path d="M27.53 17.0701H2.25C1.42 17.0701 0.75 17.7401 0.75 18.5701C0.75 19.4001 1.42 20.0701 2.25 20.0701H27.53C28.36 20.0701 29.03 19.4001 29.03 18.5701C29.03 17.7401 28.36 17.0701 27.53 17.0701Z"
			:fill="`rgb(var(--color-${color}) / 1)`"
		/>
	</svg>
</template>